import { createContext } from "react";

/** Name the page was registered with in `renderAddIn`; picks the page help in the header. */
export const AddInNameContext = createContext("");
